import { WSElement, WSModal } from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { useGetBankStatement } from "../../../query/payments/queries";
import { WSQueries } from "../../../query/WSQuery";
import { goToParentRoute } from "../../../utils/goToParentRoute";

type Props = RouteComponentProps<{ statementId: string }>;

export const MemberBankStatementModal: React.FC<Props> = ({
  history,
  match
}) => {
  const bankStatementQuery = useGetBankStatement(match.params.statementId);
  return (
    <WSModal onClose={() => goToParentRoute(history)} fullScreen>
      <WSQueries queries={{ bankStatementQuery }}>
        {({ bankStatementQuery: { data: bs } }) => {
          return <WSElement p="XS" dangerouslySetInnerHTML={{ __html: bs }} />;
        }}
      </WSQueries>
    </WSModal>
  );
};
